import { SafeAreaView, StyleSheet, ScrollView, RefreshControl, View, KeyboardAvoidingView,  Dimensions, Platform } from 'react-native';
import React, { useState, useEffect } from 'react';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { generateUniqueID } from '../../../components/AssessmentBuilderCmponent/CreateGroup/CreateGroupFunctions';
import CostumGroup from '../../../components/AssessmentBuilderCmponent/Assessment/CostumGroup';
const CreateGroup = (props) => {

    //#region Const definitions and states
    const { user, clientApi } = useAuthContext();
    const { t } = useTranslation();
    const { colors } = useTheme()
    const styles = makeStyles(colors)

    const [group, setGroup] = useState({
        assmgroupUI: generateUniqueID(), organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625", description: "", locked: "",
        require_login: true
    })
    
    useEffect(() => {
        // console.log(survId)
    }, []);

    return (
        <SafeAreaView style={[styles.main]}>
            <ScrollView>
                <CostumGroup
                    group={group}
                    setGroup={setGroup}
                    setShowResponseScreen={props.setShowResponseScreen}
                    setShowEditScreen={props.setShowEditScreen}
                    setShowCreateScreen={props.setShowCreateScreen}
                    setShowMyAssessments={props.setShowMyAssessments}
                    setShowCreateGroup = {props.setShowCreateGroup}
                    setShowEditGroup = {props.setShowEditGroup}
                    isCreate={1}
                    setShowAssessmentsAdmin={props.setShowAssessmentsAdmin}
                />
            </ScrollView>
        </SafeAreaView>
    );
};

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
        width: '100%',
    },
});

export default CreateGroup; 